module.exports = __webpack_public_path__ + "img/link06.c0fa783b.png";